// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"888eca078e129a235065","339":"39bf55571fc6e85cd1bb"}[chunkId] + ".js";
};